import React from "react"
import Card from "../../../containers/Card/Card"
import DepositProductField from "./DepositProductField/DepositProductField"
import {DepositProductProps} from "./types"
import {EditMode} from "../../../resources/common"
import classNames from "classnames"

export default function RealTimePayment({editMode, values, setFieldValue, onBlur}: DepositProductProps) {
	const realTimePaymentsEnabled = values.realTimePaymentsEnabled ?? false

	return (
		<Card
			className="deposit-product-card-title"
			title={
				<span className="card-title" id="RealTimePayment">
					Real-Time Payment
				</span>
			}
		>
			<div className={classNames("form-row four checkbox", editMode === EditMode.VIEW && "view")}>
				<DepositProductField
					mode={editMode}
					type="checkbox"
					inputType="input"
					name="realTimePaymentsEnabled"
					label="Real-Time Payments (Receive)"
					checked={realTimePaymentsEnabled}
					value={realTimePaymentsEnabled}
					onChange={() => setFieldValue("realTimePaymentsEnabled", !realTimePaymentsEnabled)}
					onBlur={onBlur}
					enableField={true}
				/>
			</div>
		</Card>
	)
}
